import { makeAutoObservable,runInAction} from "mobx";     


import { Contact, CountryCodeItem, IdentifyInfo, SellerInfo, SellerInfoDTO } from "./models/Seller";
import { MixApi } from "./apis/MixApi";
import { Storage } from "./utils/Storage";  
import "./apis/mocks/SellerMock"; 
import "./apis/mocks/BuyerMock";
import "./apis/mocks/OrderContractMock"; 
import "./apis/mocks/MixMock";
import { BuyerInfo, BuyerInfoDTO } from "./models/Buyer";
import { BuyerApi } from "./apis/BuyerApi";
import "./apis/mocks/HomeMock";
import { SellerShow } from "./models/WebResource";
import { readCustomerServiceSide } from "./utils/CustomerServiceConfig";
import { readAppDownloadUrl } from "./utils/AppDownloadUrlConfig";
import { readAppDownloadPoster } from "./utils/AppDownloadPosterConfig";
import { readEnableFullAccess } from "./utils/EnableFullAccessConfig";
import { message } from "antd";
 
class GlobalStore {
    /** 静态发布模式：true 时接口全走 mock，隐藏登录相关 */
    staticMode = false;

    constructor() {
        makeAutoObservable(this);
    }

    pollTimer: any = null;
    currentBuyer: BuyerInfoDTO | null = null; 
    userInformationChangeTrigger: boolean = false;
    orderUpdateTrigger: boolean = false;
    basicConfigs: Map<string, string> = new Map<string, string>();
    isLoggedIn: boolean = false;
    initialized: boolean = false;
    initializing: boolean = false; 
    selectedMenuKey: string = 'home';
    loginModalVisible: boolean = false;
    forceWhiteHeader: boolean = false;
    homePageAdsData: SellerShow[] | null = null;

    csContact: Contact | null = null;
    countryCodeData: CountryCodeItem = {
      code: 'CN', dialCode: '+86', name: '中国' 
    };
    

    async initDataBaseForCurrentUser(){
       //未来需要用到与用户相关的数据库，在这里初始化
    }

    async doInit(){
        console.log("__________开始初始化！");
        // 加载基础配置
        const basicConfigs = await MixApi.getBasicConfigs();
        console.log("basicConfigs", basicConfigs);
        this.basicConfigs = basicConfigs; 
        
        const buyerCs = readCustomerServiceSide(basicConfigs, 'buyer');
        this.csContact = {
            wechatImageUrl: buyerCs.qrCodeUrl,
            wechatNo: buyerCs.wechatNo,
        };
 
        const webHomeDataStr = this.basicConfigs.get("buyerWebAdData");
        if (webHomeDataStr) {
            try {
                const parsed = JSON.parse(webHomeDataStr);
                this.homePageAdsData = Array.isArray(parsed) ? parsed : [];
            } catch {
                console.warn('buyerWebAdData 解析失败');
            }
        } else {
            console.warn('buyerWebAdData 配置不存在');
        }
        if (this.staticMode) return;
        // 卖家登录信息
        const token = await Storage.getItem("token");
        if (token) {
            const data = await BuyerApi.getBuyerByToken();
            if (data) {
                console.log("登录成功，卖家信息：", data);
                this.currentBuyer = await this.covertToBuyerInfo(data);
                console.log("1111111");
                this.isLoggedIn = true;
                this.userInformationChangeTrigger = !this.userInformationChangeTrigger;
                await this.initDataBaseForCurrentUser(); 

            } else { 
                console.log('警告', '登录已过期，请重新登录');
                this.isLoggedIn = false;
                return;
            }
            
        }
        else{
            console.log("当前未登录"); 
            return;
        }   
       
    }

    async covertToBuyerInfo(data: BuyerInfoDTO): Promise<BuyerInfo> {
        return { ...data };
    }
       

    // 初始化函数
    async init(forceReinit: boolean = false) {
        if(this.initializing){
            return;
        }
        runInAction(() => {
            this.initializing = true;
        });
        this.initializing = true;
        console.log("__________初始化函数，forceReinit：", forceReinit);
       
        if (this.initialized && !forceReinit) {
            return;
        }
        console.log("即将开始初始化！");

        try {
            await this.doInit(); 
        } catch (error) {
            console.error('初始化失败:', error);
            throw error;
        } finally {
            runInAction(() => {
                this.initializing = false;
                this.initialized = true;
            });
        } 

        console.log("初始化操作全部完毕! initialized:", this.initialized);
    }
 

    /** 页脚「下载圆领APP」/ 下载弹窗：买家 APP 二维码 */
    get buyerAppQrCodeUrl(): string {
        return readAppDownloadUrl(this.basicConfigs, 'buyer');
    }

    /** 下载 APP 页三张海报 */
    get appDownloadPosters() {
        return readAppDownloadPoster(this.basicConfigs);
    }

    /** 是否开放消息、订单合同等完整能力 */
    get enableFullAccess(): boolean {
        return readEnableFullAccess(this.basicConfigs);
    }

    // 获取国家地区
    getStoreCountry() {
      return this.countryCodeData;
    }
    // 设置国家地区
    async setStoreCountry(countryCodeData: CountryCodeItem) {
      await Storage.setItem("countryCodeData", JSON.stringify(countryCodeData));
      this.countryCodeData = countryCodeData;
    }
    // 登录
    async login(phoneNo: string, password: string): Promise<boolean> {
        const data = await BuyerApi.loginByPassword(phoneNo, password);
        if (data && typeof data !== 'string') {
            await this.doLogin(data);
            return true;
        }
        throw new Error('登录失败：未获取到用户信息');
    }

    // 验证码登录
    async loginWithCode(phoneNo: string, verifyCode: string): Promise<boolean> {
        const data = await BuyerApi.loginByPhoneAndVerifyCode(phoneNo, verifyCode);
        if (data) {
            await this.doLogin(data);
            return true;
        }
        throw new Error('登录失败：未获取到用户信息');
    }


    async doLogin(data: BuyerInfoDTO) { 
        await this.init();
        runInAction(async () => {
            this.currentBuyer = await this.covertToBuyerInfo(data);
            this.isLoggedIn = true;
            this.initialized = false;
            this.initializing = false;
        }); 
    }

    // 登录
    async logout() { 
        const result = await BuyerApi.logout();
        if(!result){
            message.error("退出登录失败");
            return;
        }
        await Storage.removeItem("token");
        runInAction(() => {
            this.currentBuyer = null;
            this.isLoggedIn = false;
            this.initialized = false;
            this.initializing = false;
            this.userInformationChangeTrigger = !this.userInformationChangeTrigger;
            console.log("退出登录成功，重置状态");
        });
    }

    async updateBuyerInfo(updateData: Partial<BuyerInfoDTO>) {
        if(!this.currentBuyer?.buyerId){
            throw new Error("买家ID为空，无法更新买家信息");
        }
        
        // 调用 Repo 更新（会先保存到服务器，再更新本地数据库）
        await BuyerApi.updateBuyerInfo({
            buyerId: this.currentBuyer.buyerId,
            ...updateData
        }); 
        runInAction(() => {
            if (this.currentBuyer) {
                this.currentBuyer = {
                    ...this.currentBuyer,
                    ...updateData
                }; 
                this.userInformationChangeTrigger = !this.userInformationChangeTrigger;
            }
        }); 
       
    }
 
}

export const globalStore = new GlobalStore();